/**
 * Quick Search Functionality
 */

(function() {
  'use strict';

  let searchTimeout;
  const searchInput = document.getElementById('quick-search-input');
  const searchDropdown = document.getElementById('quick-search-dropdown');
  const searchResults = document.getElementById('quick-search-results');
  const seeAllLink = document.getElementById('quick-search-see-all');
  const searchButton = document.getElementById('quick-search-submit');

  if (!searchInput) return;

  // Handle search input
  searchInput.addEventListener('input', function(e) {
    const query = e.target.value.trim();

    // Clear previous timeout
    clearTimeout(searchTimeout);

    if (query.length < 2) {
      hideDropdown();
      return;
    }

    // Debounce search
    searchTimeout = setTimeout(() => {
      performSearch(query);
    }, 300);
  });

  // Handle search button click
  if (searchButton) {
    searchButton.addEventListener('click', function() {
      const query = searchInput.value.trim();
      if (query) {
        window.location.href = window.location.origin + '/?search=' + encodeURIComponent(query);
      }
    });
  }

  // Handle enter key
  searchInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      const query = searchInput.value.trim();
      if (query) {
        window.location.href = window.location.origin + '/?search=' + encodeURIComponent(query);
      }
    }
  });

  // Handle click outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.c-quick-search')) {
      hideDropdown();
    }
  });

  // Handle escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      hideDropdown();
    }
  });

  function performSearch(query) {
    // Show loading state
    searchResults.innerHTML = '<div class="c-quick-search__no-results">Searching...</div>';
    showDropdown();

    // Perform AJAX search using quick_search endpoint
    fetch(window.location.origin + '/wp-admin/admin-ajax.php?action=quick_search&search=' + encodeURIComponent(query) + '&per_page=5')
      .then(response => response.json())
      .then(data => {
        if (data.success && data.data) {
          displayResults(data.data.results, query);
        } else {
          searchResults.innerHTML = '<div class="c-quick-search__no-results">No results found</div>';
        }
      })
      .catch(error => {
        console.error('Search error:', error);
        searchResults.innerHTML = '<div class="c-quick-search__no-results">Error performing search</div>';
      });
  }

  function displayResults(results, query) {
    if (!results || results.length === 0) {
      searchResults.innerHTML = '<div class="c-quick-search__no-results">No results found</div>';
      return;
    }

    // Use pre-rendered HTML from server
    let html = '';
    results.forEach(result => {
      if (result.html) {
        html += result.html;
      }
    });

    searchResults.innerHTML = html;
    
    // Update "See All Results" link
    seeAllLink.href = window.location.origin + '/?search=' + encodeURIComponent(query);
  }

  function getResultType(subtype) {
    const typeMap = {
      'user': 'Member',
      'member': 'Member',
      'tribe_events': 'Event',
      'podcast': 'Podcast',
      'podcast': 'Podcast',
      'forum': 'Forum',
      'journal-entries': 'Journal Article',
      'journal_article': 'Journal Article',
      'post': 'News',
      'page': 'Page'
    };
    return typeMap[subtype] || 'Result';
  }

  function getTypeClass(type) {
    const classMap = {
      'Member': 'member',
      'Event': 'event',
      'Video': 'video',
      'Podcast': 'podcast',
      'Forum': 'forum',
      'Journal Article': 'journal',
      'News': 'event',
      'Page': 'event'
    };
    return classMap[type] || 'event';
  }

  function stripHtml(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  function showDropdown() {
    searchDropdown.style.display = 'block';
  }

  function hideDropdown() {
    searchDropdown.style.display = 'none';
  }
})();
